// extracted by mini-css-extract-plugin
module.exports = {"main":"CourseLength_main__3CxSv"};